import api from './api';

class CreditService {
  /**
   * 获取用户积分信息
   */
  async getUserCredits() {
    try {
      const response = await api.get('/credits/balance');
      return response.data;
    } catch (error) {
      console.error('获取积分信息失败:', error);
      throw error;
    }
  }

  /**
   * 获取积分交易记录
   */
  async getCreditTransactions(page = 0, size = 20, type = null) {
    try {
      const params = { page, size };
      if (type) {
        params.type = type;
      }
      const response = await api.get('/credits/transactions', { params });
      return response.data;
    } catch (error) {
      console.error('获取积分交易记录失败:', error);
      throw error;
    }
  }

  /**
   * 获取可用积分包
   */
  async getAvailablePackages() {
    try {
      const response = await api.get('/credits/packages');
      return response.data;
    } catch (error) {
      console.error('获取积分包失败:', error);
      throw error;
    }
  }

  /**
   * 购买积分包
   */
  async purchaseCreditPackage(packageId, referralCode = null) {
    try {
      const params = {};
      if (referralCode) {
        params.referralCode = referralCode;
      }
      const response = await api.post(`/credits/packages/${packageId}/purchase`, null, { params });
      return response.data;
    } catch (error) {
      console.error('购买积分包失败:', error);
      throw error;
    }
  }

  /**
   * 获取积分包购买记录
   */
  async getPurchaseHistory(page = 0, size = 20) {
    try {
      const response = await api.get('/credits/purchases', {
        params: { page, size }
      });
      return response.data;
    } catch (error) {
      console.error('获取购买记录失败:', error);
      throw error;
    }
  }

  /**
   * 获取推荐信息
   */
  async getReferralInfo() {
    try {
      const response = await api.get('/credits/referral');
      return response.data;
    } catch (error) {
      console.error('获取推荐信息失败:', error);
      throw error;
    }
  }

  /**
   * 生成分享链接
   */
  async generateReferralLink() {
    try {
      const response = await api.get('/credits/referral/link');
      return response.data;
    } catch (error) {
      console.error('生成分享链接失败:', error);
      throw error;
    }
  }

  /**
   * 消费积分
   */
  async consumeCredits(amount, description, referenceType = null, referenceId = null) {
    try {
      const params = { amount, description };
      if (referenceType) {
        params.referenceType = referenceType;
      }
      if (referenceId) {
        params.referenceId = referenceId;
      }
      const response = await api.post('/credits/consume', null, { params });
      return response.data;
    } catch (error) {
      console.error('消费积分失败:', error);
      throw error;
    }
  }

  /**
   * 获取积分系统配置
   */
  async getCreditSystemConfig() {
    try {
      const response = await api.get('/admin/credit-system-config');
      return response.data;
    } catch (error) {
      console.error('获取积分系统配置失败:', error);
      throw error;
    }
  }

  /**
   * 获取每日积分使用统计
   */
  async getDailyUsage(startDate = null, endDate = null) {
    try {
      const params = {};
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      const response = await api.get('/credits/usage/daily', { params });
      return response.data;
    } catch (error) {
      console.error('获取每日使用统计失败:', error);
      throw error;
    }
  }

  /**
   * 格式化积分数量显示
   */
  formatCredits(credits) {
    if (credits >= 1000000) {
      return (credits / 1000000).toFixed(1) + 'M';
    } else if (credits >= 1000) {
      return (credits / 1000).toFixed(1) + 'K';
    }
    return credits.toString();
  }

  /**
   * 获取交易类型的中文描述
   */
  getTransactionTypeText(type) {
    const typeMap = {
      'EARNED': '获得',
      'SPENT': '消费',
      'REFUNDED': '退款'
    };
    return typeMap[type] || type;
  }

  /**
   * 获取引用类型的中文描述
   */
  getReferenceTypeText(type) {
    const typeMap = {
      'IMAGE_GENERATION': '图片生成',
      'SUBSCRIPTION': '订阅',
      'REFUND': '退款',
      'BONUS': '奖励'
    };
    return typeMap[type] || type;
  }
}

const creditService = new CreditService();
export default creditService;